import type { ProductAvailability } from '@mevaser/shared'
import { queryKeys } from '@mevaser/shared'
import { useQuery } from '@tanstack/react-query'
import { api } from '../lib/api.js'

/**
 * "Do they even have it?" — shown per item while raising or editing a stock
 * request, against whichever location is currently chosen as the source.
 * Purely informational: a request can still be sent (and later fulfilled
 * partially) even when the source comes up short.
 */
export function SourceAvailability({
  productId,
  sourceLocationId,
  sourceName,
  qty,
}: {
  productId: string
  sourceLocationId: string
  sourceName: string
  qty: number
}) {
  const { data: availability } = useQuery({
    queryKey: queryKeys.stock.availability(productId),
    queryFn: () => api.get<ProductAvailability[]>('/stock/availability', { query: { productId } }),
  })

  if (!availability) return null

  const here = availability.find((a) => a.locationId === sourceLocationId)
  const available = here?.available ?? 0
  const name = here?.locationName ?? sourceName

  if (available >= qty) {
    return (
      <p className="text-xs text-foreground-muted">
        {available} available at {name}
      </p>
    )
  }

  return (
    <p className="text-xs text-danger">
      {available === 0 ? `None at ${name}` : `Only ${available} at ${name}`}
    </p>
  )
}
